<header id="navigation" class="navbar-header" [class.sticky]="allowHideHeader"
    [class.hidden]="utilityService.isHeaderHidden"
    [class.package-status-navbar-shown]="utilityService.isBrowser() && authService.isStudent() &&
    ((packagesFlowService.pendingPackage && packagesFlowService.pendingPackage.paymentIntent.currentInstallment != '1') || packagesFlowService.suspendedPackage)">
    @if (!utilityService.isMobileRes() && !(hideForChat && !utilityService.isDesktopRes())) {
    <app-navbar-top-bar [isLoggedIn]="!!authService.user" [isStudent]="authService.isStudent()"
        [isTeacher]="authService.isTeacher()" [showTutorGuideButton]="showTutorGuideButton"
        [contactVariable$]="variableService.contactVariable$">
    </app-navbar-top-bar>
    }
    <div class="main-navigation">
        <div class="logo" (click)="closeDropdown()">
            <a id="navbar-logo" [routerLink]="['/']" role="link" class="navbar-logo">
                <img [src]="'images.Misc_logo_rebrand.originalSource' | translate"
                    [alt]="'images.Misc_logo_rebrand.title' | translate">
            </a>
        </div>
        @defer (hydrate on idle) {
        <div class="navbar-right-section fade-in-right">
            @if (!authService.isTeacher() && !utilityService.isNL) {
            <a class="menu-item menu-item--desktop" (click)="searchService.openOrNavigateToSearch()"
                data-cy="FindTutor">
                {{ 'texts.NavigationSection_find_tutor' | translate }}
            </a>
            }
            <a class="menu-item item-price" [routerLink]="['/Misc_Pricing'] | localize"
                [class.hidden-element]="authService.user">
                {{ 'texts.NavigationSection_prices' | translate }}
            </a>
            @if (!appointment && utilityService.isBrowser() && authService.isTeacher() && !showTutorGuideButton &&
            authService.userDetails?.tutorDetails) {
            <div class="accepts-new-students-container menu-item desktop-and-tablet fade-in-right">
                <app-slide-toggle [value]="authService.userDetails.tutorDetails._acceptsNewStudents"
                    (valueChange)="authService.userDetails.tutorDetails._acceptsNewStudents = $event; updatePreference()"></app-slide-toggle>
                <p class="toggle-label">
                    {{ 'texts.NavigationSection_Tutor_Accepts_New_Students' | translate }}
                </p>
            </div>
            }
            @if (authService.isTeacher() && showTutorGuideButton) {
            <div class="tutor-guide-button">
                <button class="blue-button" [routerLink]="['/Misc_tutor_academy'] | localize">
                    <span translate>texts.Navigation_Tutor_Academy</span>
                </button>
            </div>
            }
            @if (!authService.user) {
            <div [class]="utilityService.isNL ? 'menu-item desktop-and-tablet' : 'login-button desktop-and-tablet'" (click)="openLogin()">
                <span translate>texts.NavigationSection_log_in</span>
            </div>
            }
            @if (showDesktopCredits) {
            <app-navbar-credit-display [totalCredits]="packagesFlowService.totalCredits"
                (creditInfoClicked)="openPaymentVideo()">
            </app-navbar-credit-display>
            }
            @if (showDesktopBuyButton) {
            <app-navbar-credit-display [showBuyButton]="true" (buyPackageClicked)="openBuyPackageDialog()">
            </app-navbar-credit-display>
            }
            @if (!authService.isTeacher() && utilityService.isNL) {
            <a class="find-tutor-button" (click)="searchService.openOrNavigateToSearch()"
                data-cy="FindTutor">
                {{ 'texts.NavigationSection_find_tutor' | translate }}
            </a>
            }
            @if (authService.user && appointment) {
            <div class="desktop-and-tablet">
                <app-navbar-classroom-bar [appointment]="appointment" [appointmentPartner]="appointmentPartner"
                    [appointmentType]="appointmentType" [isDE]="utilityService.isDE" (joinClassroom)="joinClassroom()">
                </app-navbar-classroom-bar>
            </div>
            }
            @if (showMobileFindTutorButton) {
            <div>
                <a (click)="searchService.openOrNavigateToSearch()" class="blue-button navbar-button"
                    data-cy="FindTutor">
                    {{ 'texts.NavigationSection_find_tutor' | translate }}
                </a>
            </div>
            }
            @if (utilityService.isBrowser() && showPackageStatus && utilityService.isDesktopRes()) {
            <div class="package-status-navbar-container">
                <app-package-status></app-package-status>
            </div>
            }
            <div class="picture-and-dropdown" [class.hide-dropdown-on-desktop]="!authService.user"
                (mouseover)="utilityService.isDesktopRes() && showDropdown()"
                (mouseleave)="utilityService.isDesktopRes() && hideDropdown($event)"
                (click)="!utilityService.isDesktopRes() && toggleOnOff(); $event.stopPropagation()">
                <div class="hamburger-icon">
                    <app-svg-icon name="hamburger-menu"></app-svg-icon>
                    @if (totalNotifications() > 0) {
                    <span class="hamburger-badge">{{ totalNotifications() }}</span>
                    }
                </div>

                <div class="user-photo">
                    @if (authService.isTeacher()) {
                    <div class="avatar-blob"></div>
                    }
                    <app-navbar-user-avatar [isLoggedIn]="!!authService.user" [image]="authService.getUser()?.image"
                        [initials]="authService.getUser()?.initials" [isAdmin]="authService.isAdmin()">
                    </app-navbar-user-avatar>
                </div>
                @if (isOpen) {
                <app-navbar-dropdown-menu (mouseleave)="hideDropdown($event)" (mouseenter)="keepDropdownOpen()"
                    (click)="closeDropdown(); $event.stopPropagation()" [isLoggedIn]="!!authService.user"
                    [isStudent]="authService.isStudent()" [isTeacher]="authService.isTeacher()"
                    [isAdmin]="authService.isAdmin()" [userImage]="authService.getUser()?.image"
                    [userInitials]="authService.getUser()?.initials" [userState]="authService.userDetails?.state"
                    [showTutorGuideButton]="showTutorGuideButton" [totalCredits]="packagesFlowService.totalCredits"
                    [hasPaidPackage]="packagesFlowService.hasPaidPackage" [hasAppointment]="!!appointment"
                    [pendingAppointmentsCount]="bookingService.pendingAppointmentsCount()"
                    [unopenedChatroomsCount]="unopenedChatroomsCount()" [isDesktopRes]="utilityService.isDesktopRes()"
                    (loginClicked)="openLogin()" (logoutClicked)="logOut()" (closeMenu)="toggleOnOff()"
                    (findTutorClicked)="searchService.openOrNavigateToSearch()"
                    (editProfileStudentClicked)="redirectToStudentEditProfile()"
                    (creditInfoClicked)="openPaymentVideo()" (buyPackageClicked)="openBuyPackageDialog()">
                </app-navbar-dropdown-menu>
                }

                <div class="overlay" [hidden]="!isOpen"></div>
            </div>
        </div>
        @if (utilityService.isBrowser() && showPackageStatus && !utilityService.isDesktopRes()) {
        <div class="package-status-navbar-container">
            <app-package-status></app-package-status>
        </div>
        }
        } @placeholder {
        <div class="navbar-right-section">
            <div class="navbar-loading">
                <i class="fa fa-spinner fa-spin"></i>
            </div>
        </div>
        }
    </div>
</header>
<div class="fade-in-down">
    @if (!appointment && toggleReady && !hideForChat && utilityService.isBrowser() && authService.isTeacher() &&
    authService.userDetails?.tutorDetails) {
    <div class="mobile-toggle-wrapper mobile">
        <div class="accepts-new-students-container fade-in-down">
            <app-slide-toggle [value]="authService.userDetails.tutorDetails._acceptsNewStudents"
                (valueChange)="authService.userDetails.tutorDetails._acceptsNewStudents = $event; updatePreference()"></app-slide-toggle>
            <p class="toggle-label">
                {{ 'texts.NavigationSection_Tutor_Accepts_New_Students' | translate }}
            </p>
        </div>
    </div>
    }
    @if (authService.user && appointment && !hideForChat) {
    <div class="mobile">
        <app-navbar-classroom-bar [appointment]="appointment" [appointmentPartner]="appointmentPartner"
            [appointmentType]="appointmentType" [isMobile]="true" [isDE]="utilityService.isDE"
            (joinClassroom)="joinClassroom()">
        </app-navbar-classroom-bar>
    </div>
    }
</div>